import TransfersList from './TransfersList';

export default TransfersList;
